module.exports = __webpack_public_path__ + "static/img/eco-protection-05.720363c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/eco-protection/eco-protection-05.jpg
// module id = fTWe
// module chunks = 100